// @flow

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import Switch from 'react-router-dom/Switch';
import Route from 'react-router-dom/Route';
import { Motion, spring } from 'react-motion';

import Header from './Header/Header';
import Footer from './Footer/Footer';
import Directions from './Directions/Directions';
import Error404 from './Error404';

import BottomDrawer from './BottomDrawer';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  min-width: 960px;

  background-color: #FCFCFC;
`;

const Viewport = styled.div`
  position: relative;
  flex: 1;

  display: flex;
  flex-direction: column;
`

type Props = Object;

type State = {
  bottomDrawerHeight: number
}

class App extends Component<void, Props, State> {
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      bottomDrawerHeight: 0,
    }
  }

  render() {
    return (
      <Root>
        <Helmet
          titleTemplate="%s — Bosti.kg"
          defaultTitle="Bosti"
        />

        <Header />

        <Viewport>
          <Switch>
            <Route
              exact
              path="/doctor/:categoryId?"
              render={matchProps => <Directions contentType="doctor" {...matchProps} />}
            />
            <Route
              exact
              path="/patient/:categoryId?"
              render={matchProps => <Directions contentType="patient" {...matchProps} />}
            />
            <Route
              exact
              path="/products/:productId"
              render={matchProps => <Directions contentType="doctor" {...matchProps} />}
            />
            <Route
              exact
              path="/articles/:articleId"
              render={matchProps => <Directions contentType="patient" {...matchProps} />}
            />
            <Route exact path="/" component={Directions} />
            <Route component={Error404} />
          </Switch>

          <Motion
            style={{ height: spring(this.state.bottomDrawerHeight) }}
            children={interpolated => (
              <div style={{ height: `${interpolated.height}px` }}>
                <BottomDrawer
                  onHeightChanged={height => this.setState({ bottomDrawerHeight: height })}
                />
              </div>
            )}
          />
        </Viewport>

        <Footer />
      </Root>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js